// global-alert.component.ts
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AlertMessage, AlertService } from '../@core/services/alert.service';

@Component({
    selector: 'app-global-alert',
    templateUrl: './global-alert.component.html',
    styleUrls: ['./global-alert.component.css'],
    standalone: false
})
export class GlobalAlertComponent implements OnInit {
  alertMessage: AlertMessage | null = null;
  readonly spinnerName = 'globalAlertSpinner';
  private readonly destroyRef = inject(DestroyRef);
  private clearTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private alertService: AlertService) { }
  clearAlert(): void {
    this.alertService.clearAlert();
  }
  ngOnInit(): void {
    this.alertService.alert$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(message => {
      this.alertMessage = message;
      if (message) {
        if (this.clearTimer) {
          clearTimeout(this.clearTimer);
        }
        this.clearTimer = setTimeout(() => this.alertService.clearAlert(), 3000);
      }
    });
  }
}
